export const FlowerPetalfallIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.1862 5.52312L13.7434 3.91261L11.5895 3.29648C10.0611 2.85924 8.41601 3.30003 7.31093 4.44293L5.7764 6.02997L4.1862 7.56755C3.0433 8.67263 2.60251 10.3177 3.03975 11.8462L3.65588 14L5.26639 12.4428C6.40929 11.3377 6.85008 9.69266 6.41284 8.16417L5.81397 6.07067L7.90755 6.66957C9.43604 7.10681 11.0811 6.66602 12.1862 5.52312Z'
        fill='#838383'
      />
      <path
        d='M5.13238 5.1693L4.01441 6.38724C3.378 7.08057 2.86489 7.87766 2.49731 8.74404L2.18659 9.47637C-0.949401 6.68453 -0.335572 3.04983 1.66969 1.19714C3.46283 -0.459247 7.51662 -0.710021 9.664 2.47724C8.23786 2.81355 6.92301 3.51318 5.8473 4.50808L5.13238 5.1693Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.06596 7.0623C5.84054 6.84906 5.66979 6.68753 5.54229 6.56003V6.27819L6.1021 5.82077L6.30327 5.79905C6.41579 5.91157 6.57398 6.06117 6.78638 6.26202C7.54388 6.97835 8.9909 8.34674 11.515 11.011C11.7194 11.2268 11.7101 11.5673 11.4944 11.7717C11.2787 11.9761 10.9381 11.9669 10.7337 11.7512C8.23964 9.11854 6.83481 7.7896 6.06596 7.0623Z'
        fill='#838383'
      />
    </svg>
  );
};
